import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {PengisianDataPribadiBsiComponent} from "./pengisian-data-pribadi-bsi.component";

const routes: Routes = [
  {
    path: 'pengisian-data-pribadi-bsi',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: PengisianDataPribadiBsiComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PengisianDataPribadiBsiRoutingModule { }
